import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { invoicesApi, INVOICE_STATUS_LABEL, INVOICE_ROW_TYPE_LABEL, type Invoice } from '../crmApi'
import { apiErrorMessage, downloadFile } from '../api'

export function InvoiceDetail() {
  const { id } = useParams()
  const invoiceId = Number(id)
  const navigate = useNavigate()
  const [invoice, setInvoice] = useState<Invoice | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    invoicesApi.get(invoiceId).then(setInvoice).catch((e) => setError(describe(e)))
  }, [invoiceId])

  async function downloadPdf() {
    try { await downloadFile(invoicesApi.pdfPath(invoiceId), `faktura-${invoiceId}.pdf`) }
    catch (e) { setError(describe(e)) }
  }

  if (error && !invoice) return <p className="error">{error}</p>
  if (!invoice) return <p className="muted">Laddar…</p>

  return (
    <div>
      <div className="page-head">
        <h1>Faktura #{invoice.id}</h1>
        <div>
          <button onClick={() => void downloadPdf()}>Ladda ner PDF</button>{' '}
          <button onClick={() => navigate(`/customers/${invoice.customerId}`)}>Till kund</button>
        </div>
      </div>
      {error && <p className="error">{error}</p>}

      <div className="card">
        <dl className="kv">
          <dt>Kund</dt><dd>{invoice.customerName}</dd>
          <dt>Fakturadatum</dt><dd>{invoice.invoiceDate}</dd>
          <dt>Förfallodatum</dt><dd>{invoice.dueDate}</dd>
          <dt>Leverans</dt><dd>{invoice.deliveryMethod === 'Email' ? 'E-post' : 'Papper'}</dd>
          <dt>Status</dt><dd><span className="badge">{INVOICE_STATUS_LABEL[invoice.status]}</span></dd>
        </dl>
      </div>

      <div className="card">
        <table className="grid">
          <thead><tr><th>Typ</th><th>Beskrivning</th><th>Antal</th><th>Á-pris</th><th>Belopp</th></tr></thead>
          <tbody>
            {invoice.rows.map((r) => (
              <tr key={r.id}>
                <td>{INVOICE_ROW_TYPE_LABEL[r.type]}</td>
                <td>{r.description}</td>
                <td>{r.quantity ?? ''}</td>
                <td>{r.unitPrice != null ? `${r.unitPrice.toFixed(2)} kr` : ''}</td>
                <td>{r.amount.toFixed(2)} kr</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr><th colSpan={4} style={{ textAlign: 'right' }}>Att betala</th><th>{invoice.total.toFixed(2)} kr</th></tr>
            <tr><td colSpan={4} style={{ textAlign: 'right' }} className="muted">Betalt</td><td className="muted">{invoice.paid.toFixed(2)} kr</td></tr>
            <tr><td colSpan={4} style={{ textAlign: 'right' }}>Kvarstår</td><td>{invoice.remaining.toFixed(2)} kr</td></tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}

const describe = apiErrorMessage
